angular
  .module('psa.module', [
    'ui.router',
    'ngMessages'
  ]);
